import isVacant from './is-vacant';

import { IOfficeholder } from '../../../types';

export default function getVacantOfficeholders(
  officeholders: IOfficeholder[]
): IOfficeholder[] {
  return officeholders.filter(officeholder =>
    isVacant(`${officeholder.givenName} ${officeholder.familyName}`)
  );
}
